
import { swapsWs } from './index.js';
const socketApi = {
  //======================ws===========================
  //订阅数据 断线重连会订阅已经订阅过的所有topic
  subSignin(token) {
    swapsWs.sub({
      event: 'signin',
      params: { token: token },
    });
  },
  sub(value) {
    swapsWs.sub({
      event: 'subscribe',
      params: value,
    });
  },
  unSub(value) {
    swapsWs.unsub({
      event: 'unsubscribe',
      params: value,
    });
  },
  resetWs(value) {
    if (value != swapsWs.url && value.indexOf('ws') > -1) {
      console.log('ws和配置不匹配，采用接口返回重连');
      swapsWs.url = value;
      swapsWs.reConnection();
    } else {
      console.log('=======>和配置一样，无需重新建立ws');
    }
  },
}
export default socketApi;


// WEBPACK FOOTER //
// ./src/assets/socket/socketApi.js